import Icon from '../components/Icon.vue'

Icon.register({
  'exclamation-triangle': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M569.5 440c18.5 32-4.7 72-41.6 72h-479.9c-36.9 0-60-40.1-41.6-72l239.9-416c18.5-32 64.7-32 83.2 0zM288 354c-25.4 0-46 20.6-46 46s20.6 46 46 46 46-20.6 46-46-20.6-46-46-46zM244.3 188.7l7.4 136c0.3 6.4 5.6 11.3 12 11.3h48.5c6.4 0 11.6-5 12-11.3l7.4-136c0.4-6.9-5.1-12.7-12-12.7h-63.4c-6.9 0-12.4 5.8-12 12.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/exclamation-triangle.js
// module id = 1307
// module chunks = 0